import React, { useState } from "react";
import CenteredModal from "../../../../../../../../components/Modal/CenteredModal";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import { api } from "../../../../../../../../api/content"; 
import { api as resourcesApi } from "../../../../../../../../api/resources";
import { ScaleLoader } from "react-spinners";
import moment from "moment/moment";
import Search from "../../../../../../../../components/Inputs/Search";
import VerticalMenu from "../../../../../../../../components/dropdown/VerticalMenu";
import MenuItem from "../../../../../../../../components/dropdown/MenuItem";
import ConfirmModal from "../../../../../zoom-integration/components/ConfirmModal";
import Pagination from "../../../../../../../../components/pagination/Pagination";  

type AllContentsModalProps = {
    openContentsModal: boolean;
    setOpenContentsModal: React.Dispatch<React.SetStateAction<boolean>>;
    refetch: () => void;
}
const AllContentsModal: React.FC<AllContentsModalProps> = ({ openContentsModal, setOpenContentsModal, refetch }) => {
  const navigate = useNavigate();
  //   const [createMeetingModal, setCreateMeetingModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState<any>(null);
  const [perPage, setPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const orgId = JSON.parse(window.sessionStorage.getItem("user")!)?.org?.id;
  const active_path = JSON.parse(sessionStorage.getItem("active-path")!);

  const [selectedContents, setSelectedContents] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectMeeting = (id: string) => {
    if (selectedContents.includes(id)) {
      setSelectedContents(
        selectedContents.filter((meetingId) => meetingId !== id)
      );
    } else {
      setSelectedContents([...selectedContents, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedContents([]);
    } else {
      setSelectedContents(contents.map((content: any) => content.id));
    }
    setSelectAll(!selectAll);
  };

  const addToResources = async (contents: any) => {
    let resourcesData = contents.map((id: string) => ({
      filePath: null, // Optional
      type: "content", // Required
      itemId: id, // id of the meeting
    }));

    let payload = {
      resourcesData,
      parentId: active_path?.id, // Required
      source: "learning-path",
    };
    try {
      toast.loading("Loading...");
      const res = await resourcesApi.createResources(payload);
      toast.dismiss();
      refetch(); 
      toast.success(res.message);
      setOpenContentsModal(false)
    } catch (error: any) {
      toast.dismiss();
      toast.error(error.response.data.message);
    }
  };

  const {
    data: contents,
    isLoading,
    refetch: refetchContents,   
  } = useQuery(
    ["all-contents", search, perPage, currentPage],
    async () => {
      const response = await api.getAllContents({
        orgId,
        search,
        perPage,
        currentPage,
      } as any);
      return response;
    },
    {
      cacheTime: 100,
      staleTime: 100,
    },
  );

  const deleteMeeting = async () => {
    if (!selectedContent) return;
    try {
      const response = await api.deleteContent({
        orgId,
        contentId: selectedContent.id,
      });
      setDeleteModal(false);
      toast.success(response.message);
      refetchContents()
      // refetch(); // Refresh the data after deletion
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <div>
      { //@ts-ignore
     <CenteredModal
         title={""}
         hasHeader={false}
         open={openContentsModal}
         setOpen={setOpenContentsModal}
         width={"w-[1200px]"}
       >
         <div className="p-4 md:p-6 overflow-auto ">
           <div className="flex justify-between mb-3">
             <h3 className="text-lg font-semibold text-[#091F46] ">
               Content Library ({contents?.meta?.total})
             </h3>
             <div className=" flex gap-6 justify-end">            
               {
                //@ts-ignore
                <Search
                 onChange={setSearch}
                 placeholder={"Search ..."}
                 className={"w-fit"}
               />
               }
             </div>
            
           </div>
           <div className="flex justify-end ">
           <button
                 className={`p-2  bg-customBlue text-white text-sm rounded-md ${
                   selectedContents.length === 0
                     ? "opacity-50 cursor-not-allowed"
                     : ""
                 }`}
                 onClick={() => addToResources(selectedContents)}
                 disabled={selectedContents.length === 0}
               >
                 Add to Resources
               </button>
           </div>
           <div className="bg-white p-3 rounded-lg shadow-sm">
             {isLoading ? (
               <div className="mt-10 flex justify-center items-center">
                 <ScaleLoader color="#FF9100" />
               </div>
             ) : (
               <div className="mt-4 ">
                 <div className="">
                   <table className="table-container">
                     <thead className="table-header">
                       <tr>
                       <th className="table-head text-center">
                           <input
                             type="checkbox"
                            // checked={selectAll}
                            // onChange={handleSelectAll}
                           />
                         </th>
                         <th className="table-head text-left">Title</th>
                         <th className="table-head">Type</th>
                         <th className="table-head">Size</th>
                         <th className="table-head text-center">Date</th>
                         <th className="table-head text-center">Action</th>
                       </tr>
                     </thead>
 
                     <tbody className="table-body text-xs">
                       {contents?.data?.length > 0 ? (
                         contents.data?.map((content: any, index: number) => (
                           <tr key={content.id}>
                             <td className="table-data">
                               <input
                                 type="checkbox"
                                 checked={selectedContents.includes(content.id)}
                                 onChange={() => handleSelectMeeting(content.id)}
                               />
                             </td>
                             <td className="table-data text-left">
                               {content.title}
                             </td>
                             <td className="table-data text-left">
                               {content.type}
                             </td>
                             <td className="table-data text-left">
                               {content.size}kb
                             </td>
 
                             <td className="table-data ">
                               {moment(content.updatedAt).format(
                                 "YYYY/MM/DD, h:mm a"
                               )}
                             </td>
 
                             <td className="table-data flex justify-center px-2">
                               {
                                 //@ts-ignore
                                 <VerticalMenu>
                                 <div className="w-fit flex flex-col gap-2">
                                   <MenuItem
                                     icon={
                                       <i className="bi bi-trash3-fill  text-red-500 cursor-pointer"></i>
                                     }
                                     label="Delete"
                                     onClick={() => {
                                       setSelectedContent(content);
                                       setDeleteModal(true);
                                     }}
                                   />
                                 </div>
                               </VerticalMenu>
                               }
                             </td>
                           </tr>
                         ))
                       ) : (
                         <tr>
                           <td className="table-data" colSpan={12}>
                             <p className="text-center">No Data Available</p>
                           </td>
                         </tr>
                       )}
                     </tbody>
                     {deleteModal && (
                        //@ts-ignore
                       <ConfirmModal
                         title="Delete Meeting"
                         description={`Are you sure you want to delete ‘‘${selectedContent?.title}”?`}
                         onYes={deleteMeeting}
                         onClose={() => setDeleteModal(false)}
                       />
                     )}
                   </table>
                 </div>
               </div>
             )}
             <section className={`mt-1 px-3 rouded-lg bg-white`}>
               <Pagination
                 data={contents?.meta}
                 perPage={perPage}
                 pageNo={currentPage}
                 setPageNo={setCurrentPage}
                 setPerPage={setPerPage}
               />
             </section>
           </div>
         </div>
         <div className="mt-5 flex justify-end">
           {/* <button
             type="button"
             onClick={() => {
               navigate("/admin/content-library");
               setOpenContentsModal(false);
             }}
             className="p-3 bg-customBlue text-white text-xs rounded-md"
           >
             Add New Content
           </button> */}
         </div>
       </CenteredModal>
      }
    </div>
  );
};

export default AllContentsModal;
